module.exports = __webpack_public_path__ + "static/users-icon-2ddcf6091028fffc23e0bfb265cedea8.png";